<template>
  <!-- FILTER START -->
  <panel :noExpand="true">
    <template slot="header">
      <h4 class="panel-title" v-if="showTitleFilter">Filter Option</h4>
    </template>
    <template>
      <div class="row">
        <!-- DEALER/MAIN DEALER FILTER START -->
        <div v-if="config.dealerExist" :class="config.dateExist ? 'col-md-9' : 'col-md-12'">
          <div class="row">
            <!-- Dealer Type Toggle -->
            <div class="col-md" v-if="!config.dealerTypeExist">
              <label>Dealer Type</label>
              <div class="onoffswitch" style="margin-top: 6px">
                <input type="checkbox" v-model="dealerType" @change="syncDealerType" class="onoffswitch-checkbox"
                  id="myonoffswitch" />
                <label class="onoffswitch-label" for="myonoffswitch">
                  <span class="onoffswitch-inner"></span>
                  <span class="onoffswitch-switch"></span>
                </label>
              </div>
            </div>

            <!-- Main Dealer Start -->
            <div v-if="dealerType"
              :class="{ mobileFilterPaddingTop: mobile, 'col-md': !config.dealerTypeExist, 'col-md-2': config.dealerTypeExist }">
              <label>Main Dealer</label>
              <MultiSelect v-if="filterOptions" v-model="filter.mainDealer" :options="filterOptions.mainDealer"
                label="name" track-by="code" :multiple="true" placeholder="All Main Dealer"></MultiSelect>
            </div>
            <div v-if="dealerType"
              :class="{ mobileFilterPaddingTop: mobile, 'col-md': !config.dealerTypeExist, 'col-md-2': config.dealerTypeExist }">
              <label for="partshopCode">Gudang</label>
              <MultiSelect v-if="filterOptions" v-model="filter.gudang" :options="filterOptions.gudang" label="name"
                track-by="code" :multiple="true" placeholder="All Gudang"></MultiSelect>
            </div>
            <!-- Main Dealer End -->

            <!-- Dealer Start -->
            <div v-if="!dealerType"
              :class="{ mobileFilterPaddingTop: mobile, 'col-md': !config.dealerTypeExist, 'col-md-2': config.dealerTypeExist }">
              <label>Karesidenan</label>
              <MultiSelect v-if="filterOptions" v-model="filter.karesidenan" :options="filterOptions.karesidenan"
                label="code" track-by="name" :multiple="true" placeholder="All Karesidenan"></MultiSelect>
            </div>
            <div v-if="!dealerType"
              :class="{ mobileFilterPaddingTop: mobile, 'col-md': !config.dealerTypeExist, 'col-md-2': config.dealerTypeExist }">
              <label for="partshopCode">Dealer</label>
              <MultiSelect v-if="filterOptions" v-model="filter.dealer" :options="filterOptions.dealer" label="name"
                track-by="code" :multiple="true" placeholder="All Dealer"></MultiSelect>
            </div>
            <!-- Dealer End -->

            <div class="col-md">
              <label for="partshopCode">Engine Number</label>
              <input type="text" class="form-control" v-model="filter.engineNo" />
            </div>
          </div>
        </div>
        <!-- DEALER/MAIN DEALER FILTER END -->

        <!-- DATE RANGE START -->
        <div v-if="config.dateExist" :class="config.dealerExist ? 'col-md-3' : 'col-md-4'">
          <div class="row">
            <!-- Range Date Start -->
            <div v-if="!config.simpleDate" class="col-md"
              style="display: flex; flex-direction: column; justify-content: center"
              :class="{ mobileFilterPaddingTop: mobile }">
              <label for="dateTimeInput">Select Date</label>
              <flat-pickr v-model="filter.dateRange" :config="rangeConfig" placeholder="Select Date" />
            </div>
            <!-- <div v-if="!config.simpleDate" class="col-md" style="display: flex; flex-direction: column; justify-content: center" :class="{ mobileFilterPaddingTop: mobile }">
              <label for="dateTimeInput">To</label>
              <flat-pickr v-model="filter.end" :config="rangeConfig" placeholder="Range Picker" />
            </div> -->
            <!-- Range Date End -->

            <!-- Simple Date Start -->
            <div v-if="config.simpleDate" class="col-md" :class="{ mobileFilterPaddingTop: mobile }">
              <label for="partshopCode">Month</label>
              <MultiSelect v-if="filterOptions" class="mt-1" :options="filterOptions.month" label="name"
                track-by="value" :multiple="false" :allow-empty="false" v-model="filter.month"
                placeholder="All Months" />
            </div>
            <div v-if="config.simpleDate" class="col-md" :class="{ mobileFilterPaddingTop: mobile }">
              <label for="partshopCode">Year</label>
              <MultiSelect v-if="filterOptions" class="mt-1" :options="filterOptions.year" :multiple="false"
                :allow-empty="false" v-model="filter.year" placeholder="All Years" />
            </div>
            <!-- Simple Date End -->
          </div>
        </div>
        <!-- DATE RANGE END -->

        <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
          <label for="partshopCode">Category</label>
          <MultiSelect v-if="filterOptions" v-model="filter.category" class="mt-1" :options="filterOptions.category"
            label="category" track-by="category" :multiple="true" placeholder="All Category"></MultiSelect>
        </div>
        <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
          <label for="partshopCode">Segment</label>
          <MultiSelect v-if="filterOptions" v-model="filter.segment" class="mt-1" :options="filterOptions.segment"
            label="segment" track-by="segment" :multiple="true" placeholder="All Segment"></MultiSelect>
        </div>
        <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
          <label for="partshopCode">Sub Series</label>
          <MultiSelect v-if="filterOptions" v-model="filter.subSeries" class="mt-1" :options="filterOptions.subSeries"
            label="subSeries" track-by="subSeries" :multiple="true" placeholder="All Sub Series"></MultiSelect>
        </div>
        <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
          <label for="partshopCode">Type</label>
          <MultiSelect v-if="filterOptions" v-model="filter.type" class="mt-1" :options="filterOptions.type"
            label="type" track-by="type" :multiple="true" placeholder="All Type"></MultiSelect>
        </div>
        <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
          <label for="partshopCode">Code - Market Name</label>
          <MultiSelect v-if="filterOptions" v-model="filter.codeMarket" class="mt-1" :options="filterOptions.codeMarket"
            label="name" track-by="codeMarket" :multiple="true" placeholder="All Code Market"></MultiSelect>
        </div>
      </div>
    </template>
    <template v-if="showExcelModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="showExcelModal = false">
            <div class="row">
              <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class="modal-container" @click.stop>
                  <div class="modal-header" style="justify-content: flex-end">
                    <button type="button" class="close" @click="showExcelModal = false">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <h4>Please Select Filter To Generate the Excel Report</h4>

                    <!-- <p class="mt-2 mb-2" style="color: red">{{ error }}</p> -->
                    <p class="mt-2 mb-2" style="color: red">*is a required field</p>

                    <!-- DEALER/MAIN DEALER FILTER START -->

                    <!-- Dealer Type Toggle -->
                    <div class="row align-items-center" v-if="!config.dealerTypeExist">
                      <div class="col-md-3">
                        <label>Dealer Type</label>
                      </div>
                      <div class="col-md-9">
                        <div class="onoffswitch" style="margin-top: 6px">
                          <input type="checkbox" v-model="dealerType" @change="syncDealerType"
                            class="onoffswitch-checkbox" id="myonoffswitch" />
                          <label class="onoffswitch-label" for="myonoffswitch">
                            <span class="onoffswitch-inner"></span>
                            <span class="onoffswitch-switch"></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Range Date Start -->
                    <div v-if="!config.simpleDate" class="row align-items-center"
                      :class="{ mobileFilterPaddingTop: mobile }">
                      <div class="col-md-3">
                        <label for="dateTimeInput">
                          <span style="color: red;">*</span>Date
                        </label>
                      </div>
                      <div class="col-md-9">
                        <flat-pickr v-model="filter.dateRange" :config="rangeConfig" placeholder="Select Date" />
                      </div>
                    </div>
                    <!-- Range Date End -->

                    <!-- Main Dealer Start -->
                    <div v-if="dealerType" :class="{ mobileFilterPaddingTop: mobile }" class="row align-items-center">
                      <div class="col-md-3">
                        <label>Main Dealer</label>
                      </div>
                      <div class="col-md-9">
                        <MultiSelect v-if="filterOptions" v-model="filter.mainDealer"
                          :options="filterOptions.mainDealer" label="name" track-by="code" :multiple="true"
                          placeholder="Select Main Dealer"></MultiSelect>
                      </div>
                    </div>
                    <div v-if="dealerType" :class="{ mobileFilterPaddingTop: mobile }" class="row align-items-center">
                      <div class="col-md-3">
                        <label for="partshopCode">Gudang</label>
                      </div>
                      <div class="col-md-9">
                        <MultiSelect v-if="filterOptions" v-model="filter.gudang" :options="filterOptions.gudang"
                          label="name" track-by="code" :multiple="true" placeholder="Select Gudang"></MultiSelect>
                      </div>
                    </div>
                    <!-- Main Dealer End -->

                    <!-- Dealer Start -->
                    <div v-if="!dealerType" :class="{ mobileFilterPaddingTop: mobile }" class="row align-items-center">
                      <div class="col-md-3">
                        <label>Karesidenan</label>
                      </div>
                      <div class="col-md-9">
                        <MultiSelect v-if="filterOptions" v-model="filter.karesidenan"
                          :options="filterOptions.karesidenan" label="code" track-by="name" :multiple="true"
                          placeholder="All Karesidenan"></MultiSelect>
                      </div>
                    </div>
                    <div v-if="!dealerType" :class="{ mobileFilterPaddingTop: mobile }" class="row align-items-center">
                      <div class="col-md-3">
                        <label for="partshopCode">Dealer</label>
                      </div>
                      <div class="col-md-9">
                        <MultiSelect v-if="filterOptions" v-model="filter.dealer" :options="filterOptions.dealer"
                          label="name" track-by="code" :multiple="true" placeholder="All Dealer"></MultiSelect>
                      </div>
                    </div>
                    <!-- Dealer End -->

                    <div class="row align-items-center">
                      <div class="col-md-3">
                        <label for="partshopCode">Engine Number</label>
                      </div>
                      <div class="col-md-9">
                        <input type="text" class="form-control" v-model="filter.engineNo" />
                      </div>
                    </div>

                    <!-- DEALER/MAIN DEALER FILTER END -->

                  </div>

                  <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
                    <label for="partshopCode">Category</label>
                    <MultiSelect v-if="filterOptions" v-model="filter.category" class="mt-1"
                      :options="filterOptions.category" label="category" track-by="category" :multiple="true"
                      placeholder="All Category"></MultiSelect>
                  </div>
                  <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
                    <label for="partshopCode">Segment</label>
                    <MultiSelect v-if="filterOptions" v-model="filter.segment" class="mt-1"
                      :options="filterOptions.segment" label="segment" track-by="segment" :multiple="true"
                      placeholder="All Segment"></MultiSelect>
                  </div>
                  <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
                    <label for="partshopCode">Sub Series</label>
                    <MultiSelect v-if="filterOptions" v-model="filter.subSeries" class="mt-1"
                      :options="filterOptions.subSeries" label="subSeries" track-by="subSeries" :multiple="true"
                      placeholder="All Sub Series"></MultiSelect>
                  </div>
                  <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
                    <label for="partshopCode">Type</label>
                    <MultiSelect v-if="filterOptions" v-model="filter.type" class="mt-1" :options="filterOptions.type"
                      label="type" track-by="type" :multiple="true" placeholder="All Type"></MultiSelect>
                  </div>
                  <div v-if="config.itemExist" class="col-md-4" style="padding-top: 20px">
                    <label for="partshopCode">Code - Market Name</label>
                    <MultiSelect v-if="filterOptions" v-model="filter.codeMarket" class="mt-1"
                      :options="filterOptions.codeMarket" label="name" track-by="codeMarket" :multiple="true"
                      placeholder="All Code Market"></MultiSelect>
                  </div>

                  <div class="row mt-4">
                    <div class="col-md-3 col-12">
                      <button type="button" @click="downloadExcel()" class="btn btn-success w-100">Download
                        Excel</button>
                    </div>
                    <div class="col-md-3 col-12">
                      <button type="button" @click="showExcelModal = false" class="btn btn-danger w-100">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
    <div v-if="showButton" class="row justify-content-end">
      <div class="col-md-3" style="display: flex; flex-direction: column-reverse; padding-top: 20px">
        <button type="button" class="btn button-new-2 d-flex align-items-center justify-content-center"
          style="height: 38px; margin-bottom: 0.5%" @click="openFilterModal">
          <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99935 8.66675L2.66602 5.33342L3.59935 4.36675L5.33268 6.10008V0.666748H6.66602V6.10008L8.39935 4.36675L9.33268 5.33342L5.99935 8.66675ZM1.99935 11.3334C1.63268 11.3334 1.3189 11.203 1.05802 10.9421C0.797127 10.6812 0.66646 10.3672 0.666016 10.0001V8.00008H1.99935V10.0001H9.99935V8.00008H11.3327V10.0001C11.3327 10.3667 11.2022 10.6807 10.9413 10.9421C10.6805 11.2034 10.3665 11.3339 9.99935 11.3334H1.99935Z"
              fill="#F36F21" />
          </svg>

          <span class="ml-2">Export To Excel</span>
        </button>
      </div>
      <div class="col-md-3" style="display: flex; flex-direction: column-reverse; padding-top: 20px">
        <button type="button" class="btn button-new-1" style="height: 38px; margin-bottom: 0.5%"
          @click="submitButton">Search</button>
      </div>
    </div>
  </panel>
  <!-- FILTER END -->
</template>

<script>
/* eslint-disable */
import flatPickr from "vue-flatpickr-component";
import Multiselect from "vue-multiselect";
import moment from "moment";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export default {
  data() {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().format("YYYY-MM-DD");
    return {
      filterReady: false,
      mobile: this.isMobile(),
      rangeConfig: {
        mode: "range",
        altInput: true,
        altInputClass: "form-control input flatpickr-input",
        dateFormat: "Y-m-d",
        altFormat: "F j, Y",
        animate: !isRTL(),
      },
      rangeConfigSeperated: {
        altInput: true,
        altInputClass: "form-control input flatpickr-input",
        animate: !isRTL(),
      },
      config: {
        dealerTypeExist: false,
        itemExist: true,
        dateExist: true,
        dealerExist: true,
        simpleDate: false,
      },
      dealerType: true,
      filterOptions: {
        mainDealer: [],
        gudang: [],
        karesidenan: [],
        dealer: [],
        category: [],
        segment: [],
        subSeries: [],
        type: [],
        codeMarket: [],
        month: [],
        year: [],
      },
      filter: {
        typeFilter: "main",
        locationType: "MAINDEALER",
        engineNo: "",
        dateRange: [],
        mainDealer: [],
        gudang: [],
        karesidenan: [],
        dealer: [],
        category: [],
        segment: [],
        subSeries: [],
        type: [],
        codeMarket: [],
        month: null,
        year: null,
      },
      showExcelModal: false,
    };
  },
  props: [
    "dealer_filter", //BOOLEAN (true or false) - DEFAULT true - Is dealer_type, main dealer, gudang, karesidenan, dealer show
    "item_filter", //BOOLEAN (true or false) - DEFAULT true - Is item filter of category, segment, subseries, type, and code market shown
    "date_filter", //BOOLEAN (true or false) - DEFAULT true - Is range date or simple date filters shown

    "dealer_type", //STRING (only 'MAIN DEALER' or 'DEALER') Leave empty or null for a switch or both
    "simple_date", //BOOLEAN (true or false) - DEFAULT false - Does it use a simple date (month and year) instead of date range

    "return_type", //RETURN TYPE ('Object' or 'String') -- string == string for params url
    "fetch_filter", //INTEGER (0, 1, 2, 3) - for update purposes, change value when update is requested

    // // "showButton", // boolean
    // "showTitleFilter", // boolean
    "filterType", // string
  ],
  components: {
    MultiSelect: Multiselect,
    flatPickr,
  },
  mounted() {
    this.loadFilter();

    // CHECK dealer_filter (dealer or main dealer filter exist)
    if (this.dealer_filter != null && typeof this.dealer_filter == "boolean") {
      this.config.dealerExist = this.dealer_filter;
      if (this.config.dealerExist) delete this.filter.locationType;
    }

    // CHECK dealer_type (forced dealer or main dealer filter)
    if (this.dealer_type != null && this.dealer_type != "") {
      if (this.dealer_type.toUpperCase() == "MAIN DEALER") {
        this.config.dealerTypeExist = true;
        this.dealerType = true;
      } else if (this.dealer_type.toUpperCase() == "DEALER") {
        this.config.dealerTypeExist = true;
        this.dealerType = false;
      } else if (this.dealer_type == null || this.dealer_type == "") {
        this.config.dealerTypeExist = null;
      } else {
        this.errorPrint("'dealer_type' can only have either 'MAIN DEALER', 'DEALER', or empty string/null");
      }
    }

    // Listen for dealerType change from other filters
    this.$root.$on("sync-dealer-type", this.handleSyncDealerType);

    //CHECK item_filter (item filter e.g. category, segment, etc exist)
    if (this.item_filter != null && typeof this.item_filter == "boolean") {
      this.config.itemExist = this.item_filter;
    }

    //CHECK date_filter (date filter e.g. range date or simple month year date)
    if (this.date_filter != null && typeof this.date_filter == "boolean") {
      this.config.dateExist = this.date_filter;
      if (!this.date_filter) {
        //clear all date filters
        delete this.filter.range;
        delete this.filter.month;
        delete this.filter.year;
      }
    }

    //CHECK simple_date (use month and year instead of date range)
    if (this.simple_date != null && typeof this.simple_date == "boolean" && this.config.dateExist) {
      this.config.simpleDate = this.simple_date;

      if (this.config.simpleDate) {
        delete this.filter.range; //clear range in filter as it is not used

        this.filter.month = {
          name: moment().format("MMMM"),
          value: parseInt(moment().format("MM")),
        };
        this.filter.year = moment().format("YYYY");
      } else {
        delete this.filter.month;
        delete this.filter.year;
      }
    }

    this.filterReady = true;
  },
  beforeDestroy() {
    this.$root.$off("sync-dealer-type", this.handleSyncDealerType);
  },
  computed: {
    showTitleFilter() {
      return this.filterType === "main";
    },
    showButton() {
      return this.filterType === "main";
    },
    // isModalFilter() {
    //   return this.filterType === "modal";
    // },
  },
  watch: {
    fetch_filter: function () {
      this.submitButton();
    },
    dealerType: function () {
      if (this.dealerType) {
        this.filter.locationType = "MAINDEALER";
        this.filter.karesidenan.length = 0;
        this.filter.dealer.length = 0;

        //Reset Gudang's Filter Option
        this.loadFilter("mainDealer");
      } else {
        this.filter.locationType = "DEALER";
        this.filter.mainDealer.length = 0;
        this.filter.gudang.length = 0;

        //Reset Dealer's Filter Option
        this.loadFilter("karesidenan");
      }
    },
    "filter.mainDealer": function () {
      this.loadFilter("mainDealer");
    },
    "filter.karesidenan": function () {
      this.loadFilter("karesidenan");
    },
    "filter.category": function () {
      this.loadFilter("category");
    },
    "filter.segment": function () {
      this.loadFilter("segment");
    },
    "filter.subSeries": function () {
      this.loadFilter("subSeries");
    },
    "filter.type": function () {
      this.loadFilter("type");
    },
    "filter.dateRange": function () {
      console.log("Filter date range:", this.filter.dateRange);
    },
  },
  methods: {
    loadFilter(type) {
      if (type == "mainDealer") {
        this.filter.gudang.length = 0;
        this.filterOptions.gudang = this.$store.getters.getGudang(this.filter.mainDealer);
      } else if (type == "karesidenan") {
        this.filter.dealer.length = 0;
        this.filterOptions.dealer = this.$store.getters.getDealer(this.filter.karesidenan);
      } else if (type == "category") {
        this.filter.segment.length = 0;
        this.filterOptions.segment = this.$store.getters.getSegment(this.filter.category);

        this.filter.subSeries.length = 0;
        this.filterOptions.subSeries = this.$store.getters.getSubSeries(this.filter.category, this.filter.segment);

        this.filter.type.length = 0;
        this.filterOptions.type = this.$store.getters.getType(this.filter.category, this.filter.segment, this.filter.subSeries);

        this.filter.codeMarket.length = 0;
        this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
      } else if (type == "segment") {
        this.filter.subSeries.length = 0;
        this.filterOptions.subSeries = this.$store.getters.getSubSeries(this.filter.category, this.filter.segment);

        this.filter.type.length = 0;
        this.filterOptions.type = this.$store.getters.getType(this.filter.category, this.filter.segment, this.filter.subSeries);

        this.filter.codeMarket.length = 0;
        this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
      } else if (type == "subSeries") {
        this.filter.type.length = 0;
        this.filterOptions.type = this.$store.getters.getType(this.filter.category, this.filter.segment, this.filter.subSeries);

        this.filter.codeMarket.length = 0;
        this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
      } else if (type == "type") {
        this.filter.codeMarket.length = 0;
        this.filterOptions.codeMarket = this.$store.getters.getCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
      } else {
        this.filterOptions = this.$store.getters.getFilterOptions;
      }
    },
    async pacifiedUrl(filter) {
      let url = new URLSearchParams();

      // Handle special case: split dateRange string
      if (filter.dateRange && typeof filter.dateRange === "string" && filter.dateRange.includes(" to ")) {
        const [start, end] = filter.dateRange.split(" to ");
        url.append("start", start.trim());
        url.append("end", end.trim());
      }

      // Loop through other fields
      for (let key in filter) {
        if (key === "dateRange") continue; // already handled

        let value = filter[key];

        if (Array.isArray(value)) {
          value.filter((v) => v != null && v !== "").forEach((val) => url.append(key, val));
        } else if (value != null && value !== "") {
          url.append(key, value);
        }
      }

      return url.toString();
    },
    async transformFilter(filter) {
      let obj = {};
      let keys = Object.keys(filter);

      for (let i = 0; i < keys.length; i++) {
        const val = filter[keys[i]];

        if (val != null && val !== "") {
          if (keys[i] === "month") {
            obj[keys[i]] = val.value;
          } else if (["year", "range", "locationType", "start", "end", "engineNo"].includes(keys[i])) {
            obj[keys[i]] = val;
          } else if (keys[i] === "dateRange" && typeof val === "string" && val.includes(" to ")) {
            const [start, end] = val.split(" to ");
            obj["start"] = start.trim();
            obj["end"] = end.trim();
          } else if (Array.isArray(val)) {
            obj[keys[i]] = [];
            for (let j = 0; j < val.length; j++) {
              if (["mainDealer", "gudang", "karesidenan", "city", "dealer"].includes(keys[i])) {
                obj[keys[i]].push(val[j] && val[j].code ? val[j].code : null);
              } else {
                obj[keys[i]].push(val[j] && val[j][keys[i]] ? val[j][keys[i]] : null);
              }
            }
          }
        }
      }

      return obj;
    },
    // async exportToExcel() {
    //   console.log(this.filterModal);
    //   this.$emit("onExport", await this.pacifiedUrl(await this.transformFilter(this.filterModal)));
    // },
    openFilterModal() {
      this.showExcelModal = true;
    },
    async downloadExcel() {
      if (this.filter.dateRange.length === 0) {
        this.$swal.fire({
          title: "Error!",
          icon: "error",
          type: "error",
          html: "<strong>Date</strong> is a required field!",
        });
        return
      }

      // Generate the filter data (URL-encoded)
      const filterData = this.return_type != null && this.return_type.toLowerCase() === "object" ? this.filter : await this.pacifiedUrl(await this.transformFilter(this.filter));

      // Prepare the URL for the download request
      const query = new URLSearchParams(filterData).toString();
      const url = `/api/reports/vehicle-search/download-excel?${query}`;

      console.log("click", url); // Check the final URL
      this.$http
        .get(url)
        .then((resp) => {
          if (resp.data && resp.data.status === "success") {
            Swal.fire({
              html: `
            <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 24 24">
              <g fill="none" stroke="#2FBF56" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                <path d="m7 12.5l3 3l7-7"/>
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10"/>
              </g>
            </svg>
            <h1 style="margin-top: 1rem;">Request Submitted</h1>
            <p>Vehicle search request has been<br>successfully submitted</p>
          `,
              showCancelButton: true,
              confirmButtonText: "OK",
              cancelButtonText: "Go to Download Page",
              customClass: {
                confirmButton: "swal-custom-ok-button",
                cancelButton: "swal-custom-download-button",
              },
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                window.location.href = "/report/report-download";
              }
            });
            this.showExcelModal = false;
          } else {
            throw new Error(resp.data.message || "Unknown error occurred");
          }
        })
        .catch((err) => {
          // console.error("Download request failed:", err);
          this.$swal.fire({
            title: "Error!",
            text: "Failed to add the report request. Please try again.",
            icon: "error",
          });
        });
    },
    async submitButton() {
      this.$emit("onFilter", this.return_type != null && this.return_type.toLowerCase() == "object" ? this.filter : await this.pacifiedUrl(await this.transformFilter(this.filter)));
    },

    syncDealerType() {
      this.$root.$emit("sync-dealer-type", this.dealerType);
    },
    handleSyncDealerType(value) {
      this.dealerType = value;
    },
  },
};

function isRTL() {
  return document.documentElement.getAttribute("dir") === "rtl" || document.body.getAttribute("dir") === "rtl";
}
</script>

<style>
/* === Date Picker Input Styling === */
.dateCss div input {
  border: 1px solid #e8e8e8;
  border-radius: 5px !important;
  height: 42px;
  margin-top: 3px;
  padding-left: 1% !important;
}

.dateCss div input::placeholder {
  padding-left: 1%;
}

/* === Modal Panel Header === */
.modal-body .panel.panel-inverse > .panel-heading {
  background: transparent;
  border-color: transparent;
}

/* === SweetAlert2 Styling === */
/* Download Button (orange filled) */
.swal2-actions .swal2-cancel.swal-custom-download-button {
  background-color: #f36f21 !important;
  color: #fff !important;
  border: 1px solid #f36f21 !important;
  border-radius: 4px;
  font-size: 13px;
  width: 190px;
  white-space: nowrap;
  text-align: left;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: none !important;
}
.swal2-actions .swal2-confirm.swal-custom-download-button {
  background-color: #f36f21 !important;
  color: #fff !important;
  border: 1px solid #f36f21 !important;
  border-radius: 4px;
  font-size: 14px;
  width: 190px;
  white-space: nowrap;
  text-align: left;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: none !important;
}
/* Container for buttons */
.swal2-actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 110%;
  gap: 10px;
}
/* OK Button (orange border, transparent bg) */
.swal2-actions .swal-custom-ok-button {
  border: 1px solid #f36f21 !important;
  border-radius: 4px;
  width: 190px;
  height: 37.8100px;
  padding-top: 5px; 
  font-size: 13px;
  white-space: nowrap;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #f36f21;
  background-color: transparent;
}
/* Cancel Button (orange border, transparent bg) */
.swal2-actions .swal-custom-cancel-button {
  border: 1px solid #f36f21 !important;
  border-radius: 4px;
  width: 190px;
  font-size: 13px;
  white-space: nowrap;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #f36f21;
  background-color: transparent;
}
/* Custom reusable button style */
.swal2-actions .swal-custom-button {
  border: 1px solid #f36f21 !important;
  border-radius: 4px;
  width: 190px;
  height: 37.75px;
  font-size: 13px;
  white-space: nowrap;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #f36f21;
  background-color: transparent;
  box-sizing: border-box;
}
/* Default confirm button override */
.swal2-styled.swal2-confirm {
  border: 1px solid #f36f21 !important;
  background-color: transparent !important;
  color: #f36f21 !important;
  box-shadow: none !important;
}
/* Remove focus shadow */
.swal2-styled:focus {
  box-shadow: none !important;
  outline: none !important;
}
</style>


<style scoped>
/* Toggle Switch Start */
.onoffswitch {
  position: relative;
  width: 130px;
  /* -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none; */
}

.onoffswitch-checkbox {
  display: none;
}

.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border-radius: 20px;
}

.onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  -moz-transition: margin 0.3s ease-in 0s;
  -webkit-transition: margin 0.3s ease-in 0s;
  -o-transition: margin 0.3s ease-in 0s;
  transition: margin 0.3s ease-in 0s;
}

.onoffswitch-inner:before,
.onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 30px;
  padding: 0;
  line-height: 30px;
  font-size: 12px;
  font-weight: 100;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.onoffswitch-inner:before {
  content: "Main Dealer";
  padding-left: 10px;
  background-color: #f16f23;
  color: #ffffff;
}

.onoffswitch-inner:after {
  content: "Dealer";
  padding-left: 10px;
  background-color: #eeeeee;
  color: #999999;
  text-align: center;
}

.onoffswitch-switch {
  display: block;
  width: 14px;
  height: 14px;
  margin: 8px;
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 0;
  bottom: 0;
  right:96px;
  -moz-transition: all 0.3s ease-in 0s;
  -webkit-transition: all 0.3s ease-in 0s;
  -o-transition: all 0.3s ease-in 0s;
  transition: all 0.3s ease-in 0s;
}

.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}

.onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
  right: 0px;
}

/* Toggle Switch End */

.mobileFilterPaddingTop {
  padding-top: 20px;
}

input {
  height: 43px;
}
</style>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}
/* MODAL ENDS */
</style>